// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubVerifyPatientResponse {
    static getAttributeTypeMap() {
        return MangoHubVerifyPatientResponse.attributeTypeMap;
    }
}
MangoHubVerifyPatientResponse.discriminator = undefined;
MangoHubVerifyPatientResponse.additionalProperties = false;
MangoHubVerifyPatientResponse.attributeTypeMap = [
    {
        "name": "isVerified",
        "baseName": "isVerified",
        "type": "boolean"
    },
];
//# sourceMappingURL=mangoHubVerifyPatientResponse.js.map